class HeaderController {
  constructor() {
    this.header = document.querySelector('.header');
    this.menuTriggers = this.header.querySelectorAll('.mega-menu-trigger');
    this.menuContents = this.header.querySelectorAll('.mega-menu__content');
    this.currentOpenMenu = null;
    
    // Мобильные элементы
    this.mobileMenuTriggers = document.querySelectorAll('.mobile-mega-menu-trigger');
    this.mobileMenuContents = document.querySelectorAll('.mobile-mega-menu__content');
    this.currentOpenMobileMenu = null;
    
    this.init();
  }
  
  init() {
    this.bindEvents();
    this.bindMobileEvents();
  }
  
  bindEvents() {
    // Клик по кнопке меню
    this.menuTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const menuIndex = trigger.dataset.menuIndex;
        this.toggleMenu(menuIndex, trigger);
      });
      
      // Поддержка клавиатуры для div
      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          const menuIndex = trigger.dataset.menuIndex;
          this.toggleMenu(menuIndex, trigger);
        }
      });
    });
    
    // Закрыть меню при клике вне
    document.addEventListener('click', (e) => {
      if (!this.header.contains(e.target)) {
        this.closeAllMenus();
      }
    });
    
    // Закрыть меню на ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeAllMenus();
      }
    });
  }
  
  bindMobileEvents() {
    // Клик по мобильному меню
    this.mobileMenuTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const menuIndex = trigger.dataset.mobileMenuIndex;
        this.toggleMobileMenu(menuIndex, trigger);
      });
      
      // Поддержка клавиатуры для мобильных div
      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          const menuIndex = trigger.dataset.mobileMenuIndex;
          this.toggleMobileMenu(menuIndex, trigger);
        }
      });
    });
  }
  
  toggleMenu(menuIndex, trigger) {
    const menuContent = document.getElementById(`MegaMenu-Content-${menuIndex}`);
    const isOpen = trigger.getAttribute('aria-expanded') === 'true';
    
    if (isOpen) {
      this.closeMenu(menuIndex, trigger, menuContent);
    } else {
      // Закрыть все другие меню
      this.closeAllMenus();
      // Открыть текущее
      this.openMenu(menuIndex, trigger, menuContent);
    }
  }
  
  toggleMobileMenu(menuIndex, trigger) {
    const menuContent = document.getElementById(`MobileMegaMenu-Content-${menuIndex}`);
    const isOpen = trigger.getAttribute('aria-expanded') === 'true';
    
    if (isOpen) {
      this.closeMobileMenu(menuIndex, trigger, menuContent);
    } else {
      // Закрыть все другие мобильные меню
      this.closeAllMobileMenus();
      // Открыть текущее
      this.openMobileMenu(menuIndex, trigger, menuContent);
    }
  }
  
  openMenu(menuIndex, trigger, menuContent) {
    trigger.setAttribute('aria-expanded', 'true');
    menuContent.style.display = 'block';
    
    // Плавное появление
    requestAnimationFrame(() => {
      menuContent.classList.add('show');
    });
    
    this.currentOpenMenu = menuIndex;
    
    // Уведомляем StickyHeader что меню открыто
    this.updateHeaderState();
  }
  
  openMobileMenu(menuIndex, trigger, menuContent) {
    trigger.setAttribute('aria-expanded', 'true');
    menuContent.classList.add('show');
    this.currentOpenMobileMenu = menuIndex;
  }
  
  closeMenu(menuIndex, trigger, menuContent) {
    trigger.setAttribute('aria-expanded', 'false');
    menuContent.classList.remove('show');
    
    // Скрыть после анимации
    setTimeout(() => {
      if (!trigger.getAttribute('aria-expanded') || trigger.getAttribute('aria-expanded') === 'false') {
        menuContent.style.display = 'none';
      }
    }, 250);
    
    if (this.currentOpenMenu === menuIndex) {
      this.currentOpenMenu = null;
    }
    
    this.updateHeaderState();
  }
  
  closeMobileMenu(menuIndex, trigger, menuContent) {
    trigger.setAttribute('aria-expanded', 'false');
    menuContent.classList.remove('show');
    
    if (this.currentOpenMobileMenu === menuIndex) {
      this.currentOpenMobileMenu = null;
    }
  }
  
  closeAllMenus() {
    this.menuTriggers.forEach(trigger => {
      const menuIndex = trigger.dataset.menuIndex;
      const menuContent = document.getElementById(`MegaMenu-Content-${menuIndex}`);
      
      if (trigger.getAttribute('aria-expanded') === 'true') {
        this.closeMenu(menuIndex, trigger, menuContent);
      }
    });
  }
  
  closeAllMobileMenus() {
    this.mobileMenuTriggers.forEach(trigger => {
      const menuIndex = trigger.dataset.mobileMenuIndex;
      const menuContent = document.getElementById(`MobileMegaMenu-Content-${menuIndex}`);
      
      if (trigger.getAttribute('aria-expanded') === 'true') {
        this.closeMobileMenu(menuIndex, trigger, menuContent);
      }
    });
  }
  
  updateHeaderState() {
    const headerWrapper = document.querySelector('.section-header');
    
    if (this.currentOpenMenu) {
      // Меню открыто - хедер белый
      headerWrapper.classList.add('header--white');
    } else {
      // Меню закрыто - проверяем нужно ли убирать белый цвет
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const stickyHeader = document.querySelector('sticky-header');
      
      if (stickyHeader && scrollTop <= stickyHeader.headerBounds?.top) {
        // В верху страницы и нет открытых меню - убираем белый
        headerWrapper.classList.remove('header--white');
      }
    }
  }
  
  isAnyMenuOpen() {
    return this.currentOpenMenu !== null || this.currentOpenMobileMenu !== null;
  }
}

// Инициализация
document.addEventListener('DOMContentLoaded', () => {
  window.headerController = new HeaderController();
});